import { Theme } from '@mui/material';
/**
 * Styling for ccf-app-scheduler
 * @returns ccf-app-scheduler CSS properties as a JSON object
 * @example ccfAppSchedulerStyles(theme, props)
 */
const ccfAppSchedulerStyles = (
  theme: Theme,
  matches: boolean,
  matchesXS?: boolean
) => {
  const styles = {
    schedulerToolBarStyles: {
      padding: '5px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      backgroundColor: matches ? theme.palette.background.paper : '#f8fafb',
      button: {
        borderRadius: 0,
        boxShadow: 'none',
        cursor: 'pointer',
        fontSize: '0.875rem',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
        border: '1px solid #dae2e8',
        height: '40px',
        ':not(:last-child)': {
          borderRight: 0,
        },
        minWidth: 'auto',
        span: {
          display: 'none',
        },
        ':hover, :disabled': {
          boxShadow: 'none',
        },
        ':active': {
          background: '#ecf5fa',
        },
      },
      '.title': {
        width: matches ? 'calc(100% - 80px)' : 'calc(100% - 120px)',
        cursor: 'auto',
        ':active, :hover': {
          background: theme.palette.background.paper,
        },
      },
      '.dateTitle': {
        width: '70%',
        cursor: 'auto',
        fontSize: '11px',
        ':active, :hover': {
          background: theme.palette.background.paper,
        },
      },
    },
    schedulerToolBarStylesWem: {
      padding: '5px',
      display: 'flex',
      flexDirection: 'row',

      backgroundColor: matches ? theme.palette.background.paper : '#f8fafb',
      button: {
        borderRadius: 0,
        boxShadow: 'none',
        cursor: 'pointer',
        fontSize: '0.875rem',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
        border: '1px solid #dae2e8',
        height: '40px',
        ':not(:last-child)': {
          // borderRight: 0,
          borderRadius: '4px',
        },
        minWidth: 'auto',
        span: {
          display: 'none',
        },
        ':hover, :disabled': {
          boxShadow: 'none',
        },
        ':active': {
          background: '#ecf5fa',
        },
      },
      '.title': {
        width: '100%',
        cursor: 'auto',
        ':active, :hover': {
          background: theme.palette.background.paper,
        },
      },
      '.dateTitle': {
        width: '70%',
        cursor: 'auto',
        fontSize: '11px',
        ':active, :hover': {
          background: theme.palette.background.paper,
        },
      },
    },
    navigatorStyles: {
      display: 'flex',
      alignItems: 'center',
      button: {
        width: '40px',
        ':first-of-type': {
          borderTopLeftRadius: '5px',
          borderBottomLeftRadius: '5px',
        },
        ':last-child': {
          borderTopRightRadius: '5px',
          borderBottomRightRadius: '5px',
        },
      },
    },
    navigatorStylesWem: {
      display: 'flex',
      alignItems: 'center',
      // maxWidth: '40% !important',
      button: {
        width: '40px',
        ':first-of-type': {
          borderTopLeftRadius: '5px',
          borderBottomLeftRadius: '5px',
        },
        ':last-child': {
          borderTopRightRadius: '5px',
          borderBottomRightRadius: '5px',
        },
      },
    },
    navigatorStylesforAppSpace: {
      display: 'flex',
      width: '73%',
      button: {
        width: '40px',
        ':first-of-type': {
          borderTopLeftRadius: '5px',
          borderBottomLeftRadius: '5px',
        },
        ':last-child': {
          borderTopRightRadius: '5px',
          borderBottomRightRadius: '5px',
        },
      },
    },
    todayButtonStyle: {
      display: matches ? 'none' : 'flex',
      'button.MuiToggleButton-root': {
        borderRadius: '5px',
        width: '90%',
        ':hover': {
          backgroundColor: '#ecf5fa',
        },
      },
      '.MuiToggleButton-root.Mui-selected': {
        color: theme.palette.secondary.main,
        backgroundColor: '#ecf5fa',
      },
    },
    viewChangerStyles: {
      alignItems: 'center',
      display: matches ? 'none' : 'flex',
      paddingLeft: '10px',
      maxWidth: '38% !important',
      button: {
        width: '50%',
        ':first-of-type': {
          borderTopLeftRadius: '5px',
          borderBottomLeftRadius: '5px',
        },
        ':last-child': {
          borderTopRightRadius: '5px',
          borderBottomRightRadius: '5px',
        },
      },
    },
    addEventButton: {
      justifyContent: 'end',
      display: 'flex',
      'button.popOverOverflow ': {
        marginLeft: '10px',
        width: '100%',
        lineHeight: '1rem',
        borderRadius: '5px',
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.background.paper,
        padding: '5px',
        fontSize: '12px',
        fontWeight: '700',
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      '.MuiButton-startIcon': {
        display: 'block',
      },
    },
    prevButtonStyle: {
      svg: {
        transform: 'rotate(-90deg)',
      },
    },
    nextButtonStyle: {
      svg: {
        transform: 'rotate(90deg)',
      },
    },
    appScheduler: {
      height: '100%',
      '.fc-timegrid-slots tr': {
        height: matches ? '55px' : '70px',
      },
      '.fc': {
        '.fc-col-header': {
          display: matches && 'none',
        },
        '.fc-scrollgrid-liquid': {
          borderTop: matches && 0,
        },
        '.fc-col-header-cell': {
          '>div': {
            display: matches && 'none',
          },
        },
      },
    },
    calendarCardStyles: {
      width: matches ? '100%' : '100%',
      height: '100%',
      overflowX: 'auto',
      overflowY: 'hidden',
      background: `${theme.palette.background.paper} 0% 0% no-repeat padding-box`,
      boxShadow: '0px 1px 3px #00000029',
      borderRadius: matchesXS ? 0 : '6px',
      opacity: 1,
      transition: 'all 0.5s ease',
      '.MuiTabs-root': {
        ...(matches
          ? {
              minHeight: 'auto',
              background: 'transparent',
              borderBottom: 'none',
            }
          : {
              minHeight: '39px',
              background: '#f8fafb 0% 0% no-repeat padding-box',
              borderBottom: '1px solid #dae2e8',
            }),
        height: matches && '32px',
        '.MuiTabs-indicator': {
          backgroundColor: theme.palette.primary.main,
          display: matches && 'none',
        },
        '.MuiTab-root': {
          minWidth: '45px',
          fontSize: '0.75rem',
          fontWeight: '600',
          margin: '1px 5px',
          color: theme.palette.secondary.main,
          padding: '16px 8px 8px',
          minHeight: 'auto',
        },
        '.Mui-selected': {
          color: matches ? '#333333' : theme.palette.primary.main,
        },
      },
    },
    tabContentSection: {
      height: matches ? 'calc(100% - 102px)' : 'calc(100% - 94px)',
      marginTop: '10px',
      borderTop: '1px solid #dae2e8',
    },
    calendarHeaderSyles: {
      background: '#f8fafb 0% 0% no-repeat padding-box',
      boxShadow: '0px 1px 3px #00000029',
      borderRadius: '5px 5px 0px 0px',
      opacity: 1,
      height: '30px',
      label: {
        font: 'normal normal 600 14px/11px OpenSans-Semibold, Open Sans',
        color: theme.palette.text.secondary,
        marginLeft: '5px',
      },
    },
    modalStyles: {
      position: 'absolute',
      top: '55%',
      left: '85%',
      transform: 'translate(-50%, -50%)',
      width: '330px',
      bgcolor: theme.palette.background.paper,
      border: '2px solid #F6F6F6',
      borderRadius: '8px',
      height: '80%',
      display: 'block',
    },
    txtMySchedule: {
      margin: '15px 0 10px 10px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '700',
      fontSize: '14px',
      lineHeight: '19px',
      textTransform: 'capitalize',
      color: '#333333',
    },
    btn: {
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      // padding: '9px 12px',
      gap: '10px',
      borderRadius: '4px !important',
      width: '60px',
      height: '30px',
      cursor: 'pointer',
      background: '#007ab8 !important',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.32)',
      marginLeft: '10px',
      minWidth: '50% !important',
    },
    btnText: {
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '600',
      fontSize: '13px',
      lineHeight: '18px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      color: '#ffffff',
    },
    overflowBtn: {
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '9px 12px',
      gap: '10px',
      borderRadius: '4px !important',
      width: '40px !important',
      height: '30px',
      cursor: 'pointer',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.32)',
      marginLeft: '10px',
    },
    accordionWemContainer: {
      boxShadow: 'none !important',
      margin: '0px !important',
      minHeight: '35px !important',
      '&$expanded': {
        margin: '0',
      },
    },
    ccfWemAccordionHeader: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      margin: '0px !important',
      minHeight: '40px !important',
      border: '1px solid #dae2e8',
      backgroundColor: '#f7f9fa',
      color: '#526b74',

      '.MuiAccordionSummary-content': {
        margin: '0px !important',
        display: 'flex',
        flexDirection: 'row',
        '&$expanded': {
          margin: '0px !important',
        },
      },
      '.MuiButtonBase-root .MuiAccordionSummary-root': {
        display: 'flex',
        flexDirection: 'row',
      },
      '.MuiAccordionSummary-expandIconWrapper': {
        position: 'absolute',
        marginRight: '15px',
        right: '0px',
        '&$expanded': {
          position: 'absolute',
          marginRight: '15px',
          right: '0px',
        },
      },
      '&$expanded': {
        margin: '0px !important',
        padding: '10px !important',
      },
      '.MuiTypography-root': {
        fontSize: '14px',
        fontFamily: 'Open Sans',
      },
    },
    accordionWemHeaderExpand: {
      display: 'flex',
      flexDirection: 'row',
      paddingLeft: '10px',
      margin: '0px !important',
      backgroundColor: '#f7f9fa',
      color: '#526b74',

      '.MuiTypography-root': {
        fontSize: '14px',
        fontFamily: 'Open Sans',
      },
    },
    expandedIcon: {
      transform: 'rotate(180deg)',
      height: '24px',
      width: '24px',
      color: `#5B7C8C`,
    },
    ccfWemAccordionDetails: {
      backgroundColor: '#ffffff',
      height: '54px',
      display: 'flex',
      alignItems: 'center',
      padding: '16px',

      p: {
        fontSize: '16px',
        color: '#526b7acc',
        opacity: '0.8',
      },
    },
  };
  return styles;
};

export default ccfAppSchedulerStyles;
